import * as tslib_1 from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { Person } from '../../../../models/person';
import { finalize, tap } from 'rxjs/operators';
import { CreatePerson, DetachCredit, LoadPerson, ResetState, UpdatePerson } from './crupdate-person-state-actions';
import { PeopleService } from '../../../../site/people/people.service';
import { TitlesService } from '../../../../site/titles/titles.service';
var CrupdatePersonState = /** @class */ (function () {
    function CrupdatePersonState(people, titles) {
        this.people = people;
        this.titles = titles;
    }
    CrupdatePersonState.person = function (state) {
        return state.person;
    };
    CrupdatePersonState.loading = function (state) {
        return state.loading;
    };
    CrupdatePersonState.credits = function (state) {
        return state.credits;
    };
    CrupdatePersonState.prototype.loadPerson = function (ctx, action) {
        var _this = this;
        ctx.patchState({ loading: true });
        return this.people.get(action.id).pipe(tap(function (response) {
            ctx.patchState({
                person: response.person,
                credits: _this.flattenCredits(response.credits),
                loading: false
            });
        }));
    };
    CrupdatePersonState.prototype.createPerson = function (ctx, action) {
        ctx.patchState({ loading: true });
        return this.people.create(action.payload).pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) { return ctx.patchState({ person: response.person }); }));
    };
    CrupdatePersonState.prototype.updatePerson = function (ctx, action) {
        ctx.patchState({ loading: true });
        return this.people.update(ctx.getState().person.id, action.payload).pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) { return ctx.patchState({ person: response.person }); }));
    };
    CrupdatePersonState.prototype.removeCredit = function (ctx, action) {
        ctx.patchState({ loading: true });
        return this.titles.removeCredit(action.id).pipe(tap(function () {
            var newCredits = ctx.getState().credits.filter(function (credit) {
                return credit.pivot.id !== action.id;
            });
            ctx.patchState({ credits: newCredits });
        }), finalize(function () { return ctx.patchState({ loading: false }); }));
    };
    CrupdatePersonState.prototype.resetState = function (ctx) {
        ctx.patchState({
            person: new Person(),
            credits: [],
            loading: false,
        });
    };
    CrupdatePersonState.prototype.flattenCredits = function (credits) {
        var flatCredits = [];
        Object.keys(credits).forEach(function (key) {
            flatCredits.push.apply(flatCredits, credits[key]);
        });
        return flatCredits;
    };
    tslib_1.__decorate([
        Action(LoadPerson),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, LoadPerson]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState.prototype, "loadPerson", null);
    tslib_1.__decorate([
        Action(CreatePerson),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, CreatePerson]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState.prototype, "createPerson", null);
    tslib_1.__decorate([
        Action(UpdatePerson),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, UpdatePerson]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState.prototype, "updatePerson", null);
    tslib_1.__decorate([
        Action(DetachCredit),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, DetachCredit]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState.prototype, "removeCredit", null);
    tslib_1.__decorate([
        Action(ResetState),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState.prototype, "resetState", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState, "person", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState, "loading", null);
    tslib_1.__decorate([
        Selector(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], CrupdatePersonState, "credits", null);
    CrupdatePersonState = tslib_1.__decorate([
        State({
            name: 'crupdatePerson',
            defaults: {
                person: new Person(),
                credits: [],
                loading: false,
            },
        }),
        tslib_1.__metadata("design:paramtypes", [PeopleService,
            TitlesService])
    ], CrupdatePersonState);
    return CrupdatePersonState;
}());
export { CrupdatePersonState };
